import React, { Component } from 'react';
import moment from 'moment';

import ImageGallery from 'react-image-gallery';
import { getPics } from '../../../utils/apiBreakfastPics';
import { StyledBoxInside } from './style';
// eslint-disable-next-line import/no-webpack-loader-syntax,import/no-unresolved
import '!!style-loader!css-loader!./style-gallery.scss';
import { API } from '../../../constants/api';

const images = [
  {
    original:
      'https://intranetapi.atresmedia.com/documents/documents01/2025/01/29/3B7F331C-84DE-40DC-B0DF-C5ABDE3C63F3/35Aniv_002.jpg',
    thumbnail:
      'https://intranetapi.atresmedia.com/documents/documents01/2025/01/29/3B7F331C-84DE-40DC-B0DF-C5ABDE3C63F3/35Aniv_002.jpg'
  }
];

class GalleryPage extends Component {
  componentDidMount() {
    getPics()
      .then(pics => {
        pics.forEach(valor => {
          images.push({
            original: API + valor.clientPath,
            thumbnail: API + valor.clientPath
          });
        });
        images.splice(0, 1);
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
  }

  render() {
    moment.locale('es');
    return (
      <div className="galery_container" style={{ backgroundColor: '#FFF' }}>
        <StyledBoxInside>
          <ImageGallery items={images} />
        </StyledBoxInside>
      </div>
    );
  }
}

export default GalleryPage;
